import styled, { css } from 'styled-components';
import Image from '@components/image';

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 4rem;
    text-align: center;

    > div {
      width: 100%;
      margin: 0 auto;
    }

    @media (max-width: ${theme.breakpoints.lg}) {
      row-gap: 3rem;
    }

    @media (max-width: ${theme.breakpoints.md}) {
      row-gap: 2.5rem;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      text-align: left;
      row-gap: 2rem;
    }
  `}
`;

export const StyledImage = styled(Image)`
  ${({ theme }) => css`
    width: 100%;
    height: auto;
    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      object-fit: cover;
      min-height: 5rem;
    }
  `}
`;
